// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".az .AZ[data-v-75b0f32a]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:40%;min-width:240px;height:120px;text-align:center;background:rgba(0,0,0,.75);color:#fff;border-radius:5px;overflow:hidden;z-index:100;line-height:120px;max-width:400px}", ""]);
// Exports
module.exports = exports;
